import { FilterProps } from '../shared';
import { SelectInput } from '@coverright/ui/inputs';
import MenuItem from '@mui/material/MenuItem/MenuItem';
import React from 'react';
import { ClientViewTimeZone } from '@coverright/data-access/types/enrollment';

export const TimezoneFilter = ({ value, onChange }: FilterProps<ClientViewTimeZone | ''>) => {
  return <SelectInput label={'Timezone'}
                      hideTick
                      validate={false}
                      value={value}
                      onChange={event => {
                        onChange(event.target.value as ClientViewTimeZone);
                      }}>
    <MenuItem value={''}>-</MenuItem>
    <MenuItem value={ClientViewTimeZone.Akst}>{ClientViewTimeZone.Akst}</MenuItem>
    <MenuItem value={ClientViewTimeZone.Cst}>{ClientViewTimeZone.Cst}</MenuItem>
    <MenuItem value={ClientViewTimeZone.Est}>{ClientViewTimeZone.Est}</MenuItem>
    <MenuItem value={ClientViewTimeZone.Hst}>{ClientViewTimeZone.Hst}</MenuItem>
    <MenuItem value={ClientViewTimeZone.Mst}>{ClientViewTimeZone.Mst}</MenuItem>
    <MenuItem value={ClientViewTimeZone.Pst}>{ClientViewTimeZone.Pst}</MenuItem>
  </SelectInput>;
};
